const iconRefresh = `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
          <path d="M0 0h24v24H0z"/>
          <path class="icon-color" d="M16.966 7.032A7.592 7.592 0 0 0 4 12.4c0 4.2 3.394 7.601 7.595 7.601a7.587 7.587 0 0 0 7.348-5.7h-1.977a5.694 5.694 0 0 1-5.37 3.8 5.7 5.7 0 1 1 0-11.4c1.572 0 2.984.655 4.016 1.686l-3.066 3.064H19.2V4.8l-2.234 2.232z" fill="#038AB7" fill-rule="nonzero"/>
      </g>
  </svg>
`

export default iconRefresh
